// Fichier: frontend/src/api/chatApi.js
import api from './api';

// --- PARTIE CLIENT ---
export const createOrGetConversation = async () => {
  const res = await api.post('/conversations');
  return res.data.conversation;
};

export const fetchMessages = async (convId) => {
  const res = await api.get(`/conversations/${convId}/messages`);
  return res.data.messages;
};

export const sendMessage = async (convId, text) => {
  const res = await api.post(`/conversations/${convId}/messages`, { body: text });
  return res.data.message;
};

// --- PARTIE ADMIN ---
export const getAllConversations = async () => {
  const res = await api.get('/admin/conversations');
  return res.data;
};

export const fetchAdminMessages = async (convId) => {
  const res = await api.get(`/admin/conversations/${convId}/messages`);
  return res.data.messages;
};

export const sendAdminMessage = async (convId, text) => {
  const res = await api.post(`/admin/conversations/${convId}/messages`, { body: text });
  return res.data.message;
};

export const startAdminConversation = async (targetUserId) => {
  const res = await api.post('/admin/conversations', { targetUserId });
  return res.data.conversation;
};

export const getUsers = async () => {
  const res = await api.get('/admin/users');
  return res.data;
};
